export default __webpack_public_path__ + "static/media/exportimg.1304af72.PNG";